export type HeroCaptionCue = {
  start: number;
  end: number;
  text: string;
};

const TIME_RE =
  /(?:(\d{2}):)?(\d{2}):(\d{2})\.(\d{3})\s+-->\s+(?:(\d{2}):)?(\d{2}):(\d{2})\.(\d{3})/;

function toSeconds(hours: string | undefined, minutes: string, seconds: string, millis: string): number {
  return (
    Number(hours ?? '0') * 3600 +
    Number(minutes) * 60 +
    Number(seconds) +
    Number(millis) / 1000
  );
}

/** Parse the hero WebVTT (no styles, no identifiers) into timed cues. */
export function parseHeroVtt(input: string): HeroCaptionCue[] {
  const lines = input.replace(/^\uFEFF/, '').split(/\r?\n/);
  const cues: HeroCaptionCue[] = [];
  for (let i = 0; i < lines.length; i++) {
    const match = TIME_RE.exec(lines[i] ?? '');
    if (!match) continue;
    const text: string[] = [];
    i += 1;
    while (i < lines.length && (lines[i] ?? '').trim() !== '') {
      text.push(lines[i] ?? '');
      i += 1;
    }
    cues.push({
      start: toSeconds(match[1], match[2] ?? '0', match[3] ?? '0', match[4] ?? '0'),
      end: toSeconds(match[5], match[6] ?? '0', match[7] ?? '0', match[8] ?? '0'),
      text: text.join('\n'),
    });
  }
  return cues;
}

export function activeHeroCaption(cues: readonly HeroCaptionCue[], time: number): string {
  const cue = cues.find((item) => time >= item.start && time < item.end);
  return cue?.text ?? '';
}
